import { brand } from './brand';

import logoWhite from 'url:../assets/logo-white.png';
import proxiaLogoWhite from 'url:../../brand-packs/proxia/logo-white.png';

// ─────────────────────────────────────────────────────────────────────────────
// The panel's own images, chosen by the brand's `assetPack`
// (docs/rebranding/CONTRACT.md §2). Same shape as the clinic panel's.
//
//   logoWhite  the white mark on the brand gradient — the rail and the sign-in card
//
// (The pack's gradient logo.png is the favicon, set by the entrypoint; nothing in
// the panel draws it, so it is not bundled.)
//
// No pack: today's bundled Parsina images, exactly as before. A pack this build
// carries (its files live in brand-packs/<pack>/, the same folder the image
// bakes and docker-entrypoint.sh serves at /brand/ for the favicon): that pack's
// images. An image the pack does NOT carry is `null`, never Parsina's — a pack
// exists precisely so nothing of Parsina's shows. Callers hide what comes back null.
// ─────────────────────────────────────────────────────────────────────────────

const PARSINA = Object.freeze({ logoWhite });

const PACKS = Object.freeze({
  proxia: Object.freeze({ logoWhite: proxiaLogoWhite }),
});

/** The pack in force, or null for today's images (none named, or one this build lacks). */
function activePack() {
  const id = brand().assetPack;
  return id && Object.prototype.hasOwnProperty.call(PACKS, id) ? PACKS[id] : null;
}

/**
 * The URL of one of the panel's images under the brand in force, or null when
 * the brand's pack has no such image.
 *
 * @param {'logoWhite'} name
 */
export function brandAsset(name) {
  const pack = activePack();
  if (!pack) return PARSINA[name] ?? null;
  return pack[name] ?? null;
}
